module.exports = __webpack_public_path__ + "static/feedback-img1-7107bd5e1a0cdf00b71ea5d398e97ad7.jpg";